import React, { useState, useEffect } from "react";
import "../scss/ContactPage.scss";
import Seo from "../components/seo/seo";

import axios from "../http/axios";

import BubblesBgHeader from "../shared/bubbles-bg-header/BubblesBgHeader";

import ContactForm from "../components/contact-form/ContactForm";

const ObfuscatedEmail = ({ user, domain }) => {
  const email = `${user}@${domain}`;
  return (
    <a href={`mailto:${email}`} className="contact-field__value cursor-pointer">
      {email}
    </a>
  );
};

const ObfuscatedPhone = ({ display }) => {
  const encoded = display
    .split("")
    .map((ch) => `&#${ch.charCodeAt(0)};`)
    .join("");

  return (
    <span
      className="contact-field__value"
      dangerouslySetInnerHTML={{ __html: encoded }}
    />
  );
};

const ContactPage = () => {
  const [recaptcha, setRecaptcha] = useState([]);

  useEffect(() => {
    axios
      .get("/recaptcha-settings")
      .then((r) => setRecaptcha(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="contact-page">
      <Seo title="Contact -" />
      <BubblesBgHeader text="Contact" />
      <div className="content-block container mt-5">
        <div className="row">
          <div className="col-lg-3">
            <div className="contacts-list d-flex flex-column gap-4">
              <div className="contacts-list__item">
                <div className="contact-field">
                  <span className="contact-field__title">Brian Lasky:</span>
                  &nbsp;
                  <span className="contact-field__value">Teacher</span>
                </div>

                <div className="contact-field">
                  <span className="contact-field__title">Email:</span>&nbsp;
                  <ObfuscatedEmail user="info" domain="gotbubbles.com" />
                </div>

                <div className="contact-field">
                  <span className="contact-field__title">Phone:</span>&nbsp;
                  <ObfuscatedPhone
                    display="310-505-9231"
                    numeric="3105059231"
                  />
                </div>
              </div>

              <div className="contacts-list__item">
                <div className="contact-field">
                  <span className="contact-field__title">Katja:</span>&nbsp;
                  <span className="contact-field__value">Scheduling</span>
                </div>

                <div className="contact-field">
                  <span className="contact-field__title">Email:</span>&nbsp;
                  <ObfuscatedEmail user="info" domain="gotbubbles.com" />
                </div>

                <div className="contact-field">
                  <span className="contact-field__title">Phone:</span>&nbsp;
                  <ObfuscatedPhone
                    display="424-209-SWIM (7946)"
                    numeric="4242097946"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <ContactForm recaptcha={recaptcha} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
